import React, { memo } from 'react';
import { ToolbarButtons } from './Toolbar.Styles';
import { NonBreakingSpace } from './Icons';
import { ToolbarButton } from './ToolbarButton';
import { EditorState, RichUtils } from 'draft-js';
export var CustomControls = memo(function (_a) {
    var onToggle = _a.onToggle, editorState = _a.editorState, bg = _a.bg;
    var currentStyle = editorState.getCurrentInlineStyle();
    var contentState = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var startKey = selection.getStartKey();
    var startOffset = editorState.getSelection().getStartOffset();
    var blockWithLinkAtBeginning = contentState.getBlockForKey(startKey);
    var linkKey = blockWithLinkAtBeginning.getEntityAt(startOffset);
    var isHardSpaceEntity = linkKey ? contentState.getEntity(linkKey).getType() === 'NONBREAKSPACE' : false;
    var isNewLineEntity = linkKey ? contentState.getEntity(linkKey).getType() === 'BR' : false;
    var blockType = editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
    var toggleHardSpace = function () {
        var contentStateWithEntity = contentState.createEntity("NONBREAKSPACE", "MUTABLE", {});
        var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
        var newEditorState = EditorState.set(editorState, { currentContent: contentStateWithEntity });
        onToggle(RichUtils.toggleLink(newEditorState, newEditorState.getSelection(), entityKey));
    };
    var toggleHardLine = function () {
        var contentStateWithEntity = contentState.createEntity("BR", "MUTABLE", {});
        var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
        var newEditorState = EditorState.set(editorState, { currentContent: contentStateWithEntity });
        onToggle(RichUtils.toggleLink(newEditorState, newEditorState.getSelection(), entityKey));
    };
    return (React.createElement(ToolbarButtons, null,
        React.createElement(ToolbarButton, { active: isHardSpaceEntity, label: React.createElement(NonBreakingSpace, null), onToggle: toggleHardSpace, style: "", blockBg: bg }),
        React.createElement(ToolbarButton, { active: isNewLineEntity, label: "NL", onToggle: toggleHardLine, style: "", blockBg: bg })));
});
